import { RouterProvider } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import router from "./router/Index";

function App() {

    return (
    <HelmetProvider>
        <div className="main-wrapper">
            <RouterProvider router={router} />
        </div>
    </HelmetProvider>
    )
}

export default App;
// <Router>
//       <Routes>
//             <Route path={process.env.PUBLIC_URL + "/"} element={<Welcome/>} />
//             <Route element={<DefaultLayout> <Outlet /> </DefaultLayout>}>
//                 <Route path={process.env.PUBLIC_URL + "/profile"} element={<Profile/>} />
//                 <Route path="*" element={<NotFound/>} />
//             </Route>
//       </Routes>
// </Router>